import "../properties/basic/Property.css"
import "./RightPanel.css"
import {observer} from "mobx-react-lite";
import {DEFAULT_GRID_SIZE, DEFAULT_TOOL_DIAMETER, globalContext} from "../editor/GlobalContext";
import React, {useState} from "react";
import PredefinedNumberSetProperty from "../properties/basic/PredefinedNumberSetProperty";
import Divider20 from "../properties/basic/Divider20";
import GCodeGenerateButton from "./GCodeGenerateButton";
import EditorMode from "../properties/EditorMode";
import GCodeSettingsBlock from "./GCodeSettingsBlock";
import ToolSelector from "./ToolSelector";
import {CncTool} from "../../service/ToolService";
import SetupToolsPanel from "./SetupToolsPanel";
import {fileEditorStore} from "../../stores/FileEditorStore";
import PropertyLink from "../properties/basic/PropertyLink";

function RightPanel() {
    const [rightPanelState, setRightPanelState] = useState({
        gridSize: DEFAULT_GRID_SIZE,
        toolDiameter: DEFAULT_TOOL_DIAMETER,
        stickGrid: true
    })

    function setGridSize(gridSize: number) {
        globalContext.editorContext().gridSize = gridSize
        setRightPanelState({
            ...rightPanelState,
            gridSize: globalContext.editorContext().gridSize
        })
    }

    function setTool(tool: CncTool) {
        globalContext.editorContext().toolDiameter = tool.diameter
        setRightPanelState({
            ...rightPanelState,
            toolDiameter: globalContext.editorContext().toolDiameter
        })
    }

    function setHoleDiameter(holeDiameter: number) {
        globalContext.editorContext().toolDiameter = holeDiameter
        setRightPanelState({
            ...rightPanelState,
            toolDiameter: globalContext.editorContext().toolDiameter
        })
    }

    function setStickGrid(stickGrid: boolean) {
        setRightPanelState({
            ...rightPanelState,
            stickGrid: stickGrid
        })
    }

    function handleClickLink() {
        fileEditorStore.toggleSlidePanelExpanded()
    }

    return <>
        <div className={"slide-right" + (fileEditorStore.getSlidePanelExpanded() ? " show" : "")}>
            <SetupToolsPanel/>
        </div>
        <div className={"props-block"}>
            <EditorMode/>
            <Divider20/>
            <Divider20 empty={true}/>
            <PredefinedNumberSetProperty
                label={"Grid size"}
                val={rightPanelState.gridSize}
                onChange={value => setGridSize(value)}
                options={[0.0508, 0.0635, 0.127, 0.254, 0.508, 0.635, 1.27, 2.54, 5.08, 6.35, 12.7]}/>

            <ToolSelector
                onChangeTool={setTool}
                onChangeHoleDiameter={setHoleDiameter}
            />

            <PropertyLink
                label={fileEditorStore.getSlidePanelExpanded() ? ">> close setup tools panel ..." : "<< setup tools ..."}
                onClick={handleClickLink}
                disabled={false}
            />

            <Divider20/>
            <GCodeGenerateButton/>
            <Divider20/>

            <GCodeSettingsBlock/>
        </div>
    </>
}

export default observer(RightPanel)